import type { PropsWithChildren } from 'react';
import { tv } from '../_lib/utils';

const styles = tv({
	slots: {
		base: 'overflow-hidden h-fit w-fit relative',
		initial: 'transition-transform duration-slow ease-smooth',
		hover: 'transition-transform duration-slow ease-smooth absolute top-full left-0',
	},
	variants: {
		direction: {
			topRight: {
				base: 'border-divider-primary',
				initial: 'group-hover/button:translate-x-full group-hover/button:-translate-y-full',
				hover: '-translate-x-full group-hover/button:translate-x-0 group-hover/button:-translate-y-full',
			},
		},
		retainHovered: {
			true: {
				initial: 'translate-x-full -translate-y-full',
				hover: 'translate-x-0 -translate-y-full',
			},
		},
	},
});

export type AnimatedIconProps = {
	className?: string;
	defaultEmpty?: boolean;
	direction?: 'topRight';
	retainHovered?: boolean;
};

export function AnimatedIcon(props: PropsWithChildren<AnimatedIconProps>) {
	const direction = props.direction ?? 'topRight';
	const retainHovered = props.retainHovered ?? false;
	const { base, initial, hover } = styles({ direction, retainHovered });
	return (
		<div className={base({ className: props.className })} data-component='AnimatedIcon'>
			<div className={initial()}>{!props.defaultEmpty && props.children}</div>
			<div className={hover()}>{props.children}</div>
		</div>
	);
}
